export enum PlatformFeature {
  CaptchaScoreThreshold = 'captchaScoreThreshold',
  TileReadsFromPlanetScale = 'tileReadsFromPlanetScale',
}
